ActivityMemberMenuView = require 'views/member-menu-profile/activity-member-menu-view'
Dates = require 'lib/dates'
Dialog = require 'views/lib/dialog'
Entity = require('views/templates/entity-react')
friendlyLinks = require 'views/internal/friendly-links'
log = require 'debug/log'
MemberAvatar = require 'views/member/member-avatar-react'
ModelCache = require 'db/model-cache'
PopOver = require 'views/lib/pop-over'
React = require 'react'
t = require('views/internal/recup-with-helpers')('notification')
Tooltip = require 'views/lib/tooltip'
l = require 'lib/localize'
track = require 'debug/track'
Util = require 'lib/util'
_ = require 'underscore'
$ = require 'jquery'

module.exports = class NotificationView extends React.Component
  el: null
  displayName: 'Notification'

  render: t.renderable ->
    { isCommentLike
    , isAddAttachment
    , unread
    , type
    , isDueDateNotification
    , isEnterpriseAdmin
    , date
    , isDeclinedInvitationNotification
    , entities
    , member
    , context
    } = @props

    t.div
      class: t.classify({
        'mod-comment-type': isCommentLike,
        'mod-attachment-type': isAddAttachment,
        'mod-unread': unread,
        'mod-due-soon': type == 'cardDueSoon'
        'phenom': true
        }),
      ref: (el) =>
        @el = el
        Dates.update(el)
        _.each el?.querySelectorAll('.js-friendly-links'), (el) ->
          friendlyLinks el
      onClick: @clickedNotification.bind(@)
    , =>
      t.div '.content-wrapper', =>
        t.div '.phenom-creator', =>
          if member
            t.div '.member.js-show-mem-menu', { 'data-idmember': member.id, onClick: @viewMemberActionMenu.bind(@) }, ->
              t.createElement MemberAvatar, member

          else
            if isDueDateNotification
              t.span '.icon-lg.icon-clock'
            else if isDeclinedInvitationNotification
              t.span '.icon-lg.icon-close'
            else
              # The user is probably deleted, but a human still did the action, so use
              # the member icon.
              t.span '.icon-lg.icon-member'

          return

        t.div '.phenom-desc', =>
          _.forEach(entities, (entity) -> t.createElement Entity, { entity, context: {}, options: { isEnterpriseAdmin } })

      t.p '.phenom-meta.quiet', ->
        if date
          t.span '.date', { 'data-date': date }

    log('notifications', @props)

  clickedNotification: (e) ->
    if @props.context == 'header'
      track("Header", "Notifications Menu", "Clicked Notification")
    else if @props.context == 'notifications-page'
      track("Member View", "Notifications Page", "Clicked Notification")

    # If the user clicked somewhere on the notification that wasn't a link, make our best guess as to where
    # they'd like to be sent.  For example, if it's a notification for a card, send them to the card.
    @props.markRead()
    if !$(e.target).is('a')
      @props.navigateToView()
      Util.stop(e)
    else if !(e.metaKey || e.ctrlKey)
      Dialog.hide() # Will no-op in when we're not in a dialog.

  viewMemberActionMenu: (e) ->
    Util.stop(e)

    member = ModelCache.get('Member', $(e.target).closest('[data-idmember]').attr("data-idmember") ? @props.idMemberCreator)

    if $(e.target).closest('.pop-over').length > 0
      PopOver.pushView
        view: ActivityMemberMenuView
        options:
          model: member
          modelCache: ModelCache

    else
      PopOver.toggle
        elem: $(e.target).closest('.js-show-mem-menu')
        view: ActivityMemberMenuView
        options:
          model: member
          modelCache: ModelCache

    return



// WEBPACK FOOTER //
// ./app/scripts/views/notification/notification-view-legacy.coffee